import { Checkbox } from "@material-ui/core";
import { ColDef } from "ag-grid-enterprise";
import { CatalogResultSource } from "../../../models/CatalogResultSource";
import { useCatalogResultSourceContext } from "../CatalogResultSourceContext";

type Props = {};
export const useTableData = ({}: Props) => {
	const { state } = useCatalogResultSourceContext();
	const rows: CatalogResultSource[] =
		state.resultSources?.map((resultSource) => ({
			...resultSource,
		})) || [];

	const columns: ColDef[] = [
		{ field: "ResultSourceName", headerName: "Name", minWidth: 20, flex: 1 },
		{
			field: "IsActive",
			headerName: "Enabled",
			cellRenderer: (params: any) => {
				return <Checkbox checked={params.value} disabled={true} />;
			},
			flex: 1,
			minWidth: 100,
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "Actions",
			headerName: "",
			type: ["editButton"],
			flex: 1,
			minWidth: 80,
			maxWidth: 80,
		},
	];
	const defaultColDef: ColDef = {
		flex: 1,
		autoHeight: true,
		wrapText: true,
		sortable: true,
	};
	return { rows, columns, defaultColDef };
};
